import { twMerge } from 'tailwind-merge';

export interface FieldErrorProps {
  message?: string;
  className?: string;
}

/**
 * The validation message under a field.
 *
 * The line it occupies is held whether or not there is a message, so a field that
 * fails validation doesn't push its neighbours around as the message appears and
 * clears. Rows of fields are laid out with `items-start` for the same reason: under
 * `items-center` one field growing taller re-centres every other field beside it.
 */
export const FieldError = ({ message, className }: FieldErrorProps) => (
  <div className={twMerge('min-h-4 mt-1 text-error-500 text-xs', className)}>{message}</div>
);

export default FieldError;
